const C = "#00A3E0", M = "#E40046", Y = "#FFB800";
const GRID = [
  [C, M, M, Y, Y, M],
  [M, Y, M, C, Y],
  [C, M, Y, M, Y],
  [M, C, Y, Y],
  [Y, M, C, M],
  [C, Y, M],
];

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 68 68" className={className} aria-hidden>
    <defs><clipPath id="pe-r"><rect x="2" y="4" width="54" height="54" rx="12" /></clipPath></defs>
    <g clipPath="url(#pe-r)">
      <rect x="2" y="4" width="54" height="54" fill={C} />
      {GRID.map((row, r) => row.map((fill, c) => <rect key={`${r}-${c}`} x={2 + c * 9} y={4 + r * 9} width="9.2" height="9.2" fill={fill} />))}
      <path d="M44 4 C 56 12, 40 26, 30 34 C 20 42, 18 52, 30 60 L 60 60 L 60 4 Z" fill={C} />
      <path d="M44 4 C 56 12, 40 26, 30 34 C 20 42, 18 52, 30 60" stroke="#fff" strokeWidth="4.5" fill="none" />
    </g>
    <path d="M44 2 C 52 2, 58 6, 60 14" stroke={Y} strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d="M60 46 L 47 61 L 34 65" stroke="#0F172A" strokeWidth="1.3" fill="none" />
    <circle cx="60" cy="46" r="2.3" fill="#fff" stroke={C} strokeWidth="1.6" />
    <circle cx="34" cy="65" r="2.3" fill="#fff" stroke={C} strokeWidth="1.6" />
    <circle cx="47" cy="61" r="3.6" fill={C} stroke="#fff" strokeWidth="1.4" />
  </svg>
);

export const CmykMark = ({ size = 10 }) => (
  <span className="inline-flex items-center gap-[3px]" aria-hidden>
    {["#00A3E0", "#E40046", "#FFB800", "#0F172A"].map((c) => (
      <span key={c} style={{ width: size, height: size, background: c }} className="rounded-full" />
    ))}
  </span>
);

export const Logo = () => (
  <span className="flex items-center gap-2" aria-label="PixelEdit Pro">
    <LogoMark />
    <span className="flex items-center gap-1.5 font-display text-xl font-bold tracking-tight text-slate-900">
      PixelEdit
      <span className="rounded-full bg-[#00A3E0] px-2 py-0.5 text-xs font-bold leading-none text-white">Pro</span>
    </span>
  </span>
);
